<template lang="pug">
.turbid
  j-table(:data="turbid", :showTypes="showTypes", :showColumnHeader="false")
</template>

<script>
import { defineComponent, reactive } from 'vue';
import JTable from '@/components/JTable.vue';
import turbid from '@/utils/turbid';

export default defineComponent({
  name: 'Turbid',
  components: {
    JTable,
  },
  props: {
    showTypes: Array,
  },
  setup() {
    console.log('turbid==', turbid);
    const pageData = reactive({
      turbid,
    });
    return pageData;
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .turbid
    display block
</style>
